import { render, staticRenderFns } from "./coreCompliance.vue?vue&type=template&id=266576d0&scoped=true&"
import script from "./coreCompliance.vue?vue&type=script&lang=js&"
export * from "./coreCompliance.vue?vue&type=script&lang=js&"
import style0 from "./coreCompliance.vue?vue&type=style&index=0&id=266576d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266576d0",
  null
  
)

export default component.exports